var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 22,
    viewBox: "0 0 65 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1098_1275)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.8055 21.0324H22.6075L25.8587 0.865234H31.0564L27.8055 21.0324Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.6484 1.3586C45.6232 0.950543 43.997 0.5 41.9863 0.5C36.8532 0.5 33.2384 3.24603 33.2163 7.17202C33.1736 10.0686 35.8043 11.6775 37.7718 12.6433C39.7828 13.6302 40.4665 14.2743 40.4665 15.154C40.446 16.5051 38.8414 17.1279 37.3449 17.1279C35.2696 17.1279 34.1577 16.8068 32.4679 16.0551L31.7834 15.7329L31.056 20.26C32.2751 20.8172 34.5212 21.3117 36.8532 21.3333C42.3072 21.3333 45.858 18.6298 45.9 14.446C45.9208 12.1502 44.5317 10.3911 41.5369 8.95366C39.7189 8.03091 38.6055 7.4087 38.6055 6.46456C38.6268 5.60625 39.5472 4.72712 41.5994 4.72712C43.2893 4.68406 44.5308 5.09154 45.4714 5.49931L45.9415 5.71346L46.6484 1.3586Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.557 13.8879C53.985 12.7293 55.6322 8.2453 55.6322 8.2453C55.6106 8.28835 56.0594 7.06533 56.3161 6.31452L56.6794 8.05225C56.6794 8.05225 57.6637 12.8796 57.8775 13.8879C57.0651 13.8879 54.5837 13.8879 53.557 13.8879ZM59.9732 0.865234H55.9526C54.7127 0.865234 53.7707 1.22966 53.2358 2.53852L45.5149 21.0322H50.9689C50.9689 21.0322 51.8669 18.543 52.0599 18.007C52.6582 18.007 57.9639 18.007 58.7336 18.007C58.8828 18.715 59.3538 21.0322 59.3538 21.0322H64.1666L59.9732 0.865234Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.266 0.865234L13.1755 14.6173L12.6192 11.8283C11.6781 8.61001 8.72654 5.11345 5.43274 3.37487L10.0955 21.0111H15.5921L23.7624 0.865234H18.266Z",
    fill: "#00579F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.44854 0.865234H0.0855567L0 1.27272C6.52365 2.94629 10.8441 6.98035 12.6192 11.8291L10.8012 2.56047C10.5019 1.27243 9.5821 0.907722 8.44854 0.865234Z",
    fill: "#FAA61A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1098_1275"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 64.1666,
    height: 20.8333,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.9ee5750097e2f103bc0c48fe37f8fdbc.svg";
export { ForwardRef as ReactComponent };